import {
  Card,
  CardMedia,
  CardContent,
  Stack,
  Typography,
  Tooltip,
} from '@mui/material'
import { Info } from '@mui/icons-material'
import { Value, VariableLabel } from '@k3/core'
import { VariableComponentProps } from '@k3/core/src/lib/types/variableUiTypes'
import { VariableT } from '@k3/core/src/lib/types/variable.interface'
import { useState } from 'react'

const getIdentifier = (p: VariableT | Value, prefix = '') => {
  return `${prefix}_${p.key ?? p.id}`
}

export const SelectCard = (props: VariableComponentProps) => {
  const handleChange = (valueId: number) => {
    props.onChange(valueId)
  }
  const [focus, setFocus] = useState<number>()

  const variable = props.variable
  const vIdentifier = getIdentifier(variable, 'variable')
  return (
    <>
      <Stack sx={{ pb: 1 }}>
        <VariableLabel variable={variable} />
      </Stack>
      {props.values.map((p) => {
        const active = props?.selection?.valueId === p.id
        const valueIdentifier = getIdentifier(p, 'value')
        return (
          <label key={p.id}>
            <input
              type={'radio'}
              name={vIdentifier}
              id={valueIdentifier}
              value={p.id}
              checked={active}
              onChange={() => handleChange(p.id)}
              onFocus={() => setFocus(p.id)}
              onBlur={() => setFocus(undefined)}
              style={{ position: 'absolute', opacity: 0 }}
            />

            <Card
              sx={[
                {
                  maxWidth: '100%',
                  cursor: 'pointer',
                  margin: '0 auto 8px auto',
                  transition: 'all .4s',
                  borderStyle: 'solid',
                  borderWidth: '2px',
                  borderColor: (theme) => {
                    return active ? theme.palette.primary.main : 'transparent'
                  },
                },
                {
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
                {
                  backgroundColor:
                    focus === p.id ? 'rgba(0, 0, 0, 0.04)' : null,
                },
              ]}
            >
              <CardContent
                sx={{
                  '&:last-child': {
                    paddingBottom: '5px',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="100"
                  image={p.thumbnail ?? undefined}
                  alt={p.label}
                  sx={{
                    objectFit: 'contain',
                  }}
                />
                <CardContent
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    color="text.primary"
                    sx={{
                      fontSize: '1.0rem',
                      flex: '1 1 75%',
                    }}
                  >
                    {p.label}
                  </Typography>
                  <Tooltip title={p.info}>
                    <Info
                      color={'action'}
                      sx={{
                        width: '100%',
                        justifyContent: 'end',
                        flex: '1 1 1%',
                      }}
                    />
                  </Tooltip>
                  {variable.settings.templateOptions?.showDescription && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        fontSize: '0.625rem',
                      }}
                    >
                      {p.description}
                    </Typography>
                  )}
                </CardContent>
              </CardContent>
            </Card>
          </label>
        )
      })}
    </>
  )
}
